import { Component, markRaw } from 'vue'
import { GraphQLLeafType } from 'graphql/type'
import AccountsGraphqlFilter from '@/components/GraphqlDataTable/filters/accounts/AccountsGraphqlFilter.vue'
import WorkersGraphqlFilter from '@/components/GraphqlDataTable/filters/accounts/WorkersGraphqlFilter.vue'
import CompaniesGraphqlFilter from '@/components/GraphqlDataTable/filters/accounts/CompaniesGraphqlFilter.vue'
import { InputValueFragment } from '@/gql/graphql'
import DateRangeFilter from '@/components/GraphqlDataTable/filters/Dates/DateRangeFilter.vue'
import ExternalIdentifiersGraphqlFilter from '@/components/GraphqlDataTable/filters/hires/ExternalIdentifiersGraphqlFilter.vue'
import StatusGraphqlFilter from './hires/StatusGraphqlFilter.vue'
import JobOwnersGraphqlFilter from '@/components/GraphqlDataTable/filters/accounts/JobOwnersGraphqlFilter.vue'

export enum FilterTypes {
  SELECT,
  TOGGLE,
  SINGLE_STRING,
  COMPONENT,
}

// This interface represents the meta data that can be use to further fit a filter to the input data
// Its accessible via the meta property on all filter components
export interface FilterMetaDataProp {
  filter: {
    name: string
    component?: Component
    title?: string
    description?: string
    placeholder?: string
    multiSelect?: boolean
    list?: any[]
    type: FilterTypes
  }
  graphqlData: {
    listType: boolean
    leaf: GraphQLLeafType
    arg: InputValueFragment
  }
}

// Register filters here with one of two key types:
// GraphQLDataType: markRaw(GraphQLDataTypeFilterComponent)
// or $argumentName-argumentType: markRaw(ComplexFilterComponent)
// Sometimes filters can be generated on the fly or there already exists a version using a different argument name
// check them over before making a new account.
export default {
  'accounts-[ID!]': markRaw(AccountsGraphqlFilter),
  'companies-[ID!]': markRaw(CompaniesGraphqlFilter),
  DateRangeInput: markRaw(DateRangeFilter),
  'workers-[ID!]': markRaw(WorkersGraphqlFilter),
  'externalIdentifiers-[String!]': markRaw(ExternalIdentifiersGraphqlFilter),
  'activeStatus-[HireActiveStatus!]': markRaw(StatusGraphqlFilter),
  'jobOwners-[ID!]': markRaw(JobOwnersGraphqlFilter),
}
